import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogHeader, DialogTitle, } from '@cargomatic/ui';
import { withTranslation } from 'react-i18next';
import TripPlannerForm from './trips/TripPlannerForm';
import TripsActionCreator from '../../../actions/TripsActionCreator';
import TripFormStore from '../../../stores/TripFormStore';
import TripsStore from '../../../stores/TripsStore';
import { getNewTrip } from '../../../helpers/trip-helper';
class TripPlannerModal extends Component {
    constructor(props) {
        super(props);
        this.handleTripAppliedEvent = () => {
            setTimeout(() => {
                this.props.onClose();
            }, 500);
        };
        this.handleTripFormStoreChange = () => {
            const tripContext = TripFormStore.getTripContext();
            const { formStatus, trip } = tripContext;
            const { pending, success } = formStatus;
            if (pending) {
                this.setState({
                    formStatus,
                });
                return;
            }
            if (success) {
                this.setState({
                    trip,
                    formStatus,
                }, () => TripsActionCreator.getTrips());
            }
            else {
                this.setState({
                    formStatus,
                });
            }
        };
        this.handleTripsStoreChange = () => {
            const trips = TripsStore.getTrips();
            this.setState({
                trips,
            });
        };
        this.handleClose = () => this.props.onClose();
        this.handleCreateTrip = (payload) => {
            TripsActionCreator.createTrip(payload);
        };
        this.handleUpdateTrip = (payload) => {
            TripsActionCreator.updateTrip(payload);
        };
        this.handleSaveAndApplyTrip = (trip) => {
            const { orderId } = this.props;
            TripsActionCreator.saveAndApplyTrip(orderId, trip);
        };
        this.handleTripSelect = (e) => {
            const { target: { value: tripId }, } = e;
            this.setState((prevState) => {
                const { trips } = prevState;
                const { carrier } = this.props;
                let trip;
                if (!tripId) {
                    trip = getNewTrip({
                        carrier,
                        sequence: 1,
                    });
                }
                else {
                    const selectedTrip = trips.find((t) => t._id === tripId);
                    trip = mapSelectedTrip({
                        carrier,
                        trip: selectedTrip,
                    });
                }
                return {
                    trip,
                };
            });
        };
        const trip = getNewTrip({
            carrier: props.carrier,
            sequence: 1,
        });
        this.state = {
            trip,
            trips: [],
            formStatus: {
                pending: false,
                completed: false,
                success: false,
                error: null,
            },
        };
    }
    componentDidMount() {
        TripFormStore.addChangeListener(this.handleTripFormStoreChange);
        TripFormStore.addTripAppliedEventListener(this.handleTripAppliedEvent);
        TripsStore.addChangeListener(this.handleTripsStoreChange);
        TripsActionCreator.getTrips();
    }
    componentWillUnmount() {
        TripFormStore.removeChangeListener(this.handleTripFormStoreChange);
        TripFormStore.removeTripAppliedEventListener(this.handleTripAppliedEvent);
        TripsStore.removeChangeListener(this.handleTripsStoreChange);
    }
    renderTripsDropdown() {
        const { trip: currentTrip, trips } = this.state;
        if (trips.length === 0) {
            return null;
        }
        const { t } = this.props;
        return (React.createElement("select", { className: "", value: currentTrip._id || '', onChange: this.handleTripSelect },
            React.createElement("option", { value: "" }, t('CREATE_A_TRIP')),
            trips.map((trip) => (React.createElement("option", { key: trip._id, value: trip._id }, trip.name)))));
    }
    render() {
        const { carrier, equipments, show, t, shipperId } = this.props;
        return (React.createElement(Dialog, { open: show, onOpenChange: this.handleClose },
            React.createElement(DialogContent, { className: "w-screen h-screen max-w-none max-h-none overflow-y-auto" },
                React.createElement(DialogHeader, null,
                    React.createElement("div", { className: "flex" },
                        React.createElement("div", { className: "mr-4 flex-1" },
                            React.createElement(DialogTitle, null, t('TRIP_PLANNER'))),
                        this.renderTripsDropdown())),
                React.createElement(TripPlannerForm, { trip: this.state.trip, carrier: carrier, shipperId: shipperId, equipments: equipments, onCreateTrip: this.handleCreateTrip, onUpdateTrip: this.handleUpdateTrip, onSaveAndApplyTrip: this.handleSaveAndApplyTrip, formStatus: this.state.formStatus }))));
    }
}
TripPlannerModal.propTypes = {
    orderId: PropTypes.string.isRequired,
    shipperId: PropTypes.string,
    carrier: PropTypes.shape({
        _id: PropTypes.string,
        name: PropTypes.string,
    }),
    equipments: PropTypes.arrayOf(PropTypes.shape({
        _id: PropTypes.string,
        equipment_id: PropTypes.string,
    })),
    show: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
};
TripPlannerModal.defaultProps = {
    equipments: [],
    show: false,
};
function mapSelectedTrip({ trip, carrier: orderCarrier }) {
    const { _id, name } = trip;
    const legs = trip.legs.map((leg) => {
        const { sequence: legSequence, shipment_type, status } = leg;
        let carrier;
        let carrier_id;
        if (orderCarrier && orderCarrier.authorized) {
            carrier = orderCarrier.name;
            carrier_id = orderCarrier._id;
        }
        const stops = leg.stops.map((stop) => {
            const { sequence, action, empty, location } = stop;
            return {
                sequence,
                action,
                empty,
                location,
                equipments: [],
            };
        });
        return {
            sequence: legSequence,
            status,
            shipment_type,
            carrier,
            carrier_id,
            stops,
        };
    });
    return {
        _id,
        name,
        legs,
    };
}
export default withTranslation()(TripPlannerModal);
